module.exports = __webpack_public_path__ + "static/media/sede.0be03ff0.jpg";